<template>
  <div>
    <!-- Fixed Header, Shows on Scroll Doubles as Mobile Page Header -->
    <header class="page-header product fixie" v-if="product.isStock || product.isLive">
      <div class="wrapper">
        <div class="title">
          <h1>{{ product.title }}</h1>
          <h3>
            <span class="by">By</span>
            <a :href="product.designer.url">{{ product.designer.name }}</a>
            <span v-if="product.type === 'clothing'" class="price">
              <em>—</em>
              <span v-if="userMadeFinalChoice">Size {{ selectedOptions[4].name }},</span>
              ${{ selectedVariant.price }}
            </span>
          </h3>
        </div>
        <aside>
          <div class="buy">
            <div class="selected-options">
              <template v-if="product.type === 'clothing'">
                <span>
                  {{ selectedOptions[1].name }}
                  <em v-if="['Men', 'Women'].some((gender) => selectedOptions[1].name === gender)">'s</em>
                  {{ selectedOptions[2].name }}
                </span>
                <span>{{ selectedOptions[3].name }}</span>
                <span>Size {{ selectedOptions[4].name }}</span>
              </template>
              <template v-else>
                <span v-for="(choice, choiceIndex) in activeChoices">{{ choice.title }} {{ selectedOptions[choiceIndex].name }}</span>
              </template>
            </div>
            <div class="price">
              <span class="symbol">$</span>
              {{ selectedVariant.price }}
            </div>
            <button class="buy-button" :disabled="isSubmitting || !selectedVariant.availableForSale || !userMadeFinalChoice" @click.prevent.stop="addToBag">
              <span v-show="!isSubmitting">
                <span class="desktop">Add to Cart</span>
                <span class="mobile">
                  <symbol-icon icon-name="cart-stroke" class="icon" view-box="0 0 24 24" />
                </span>
              </span>
              <VueSpinner v-show="isSubmitting" color="#ff523f" />
            </button>
          </div>
        </aside>
      </div>
    </header>

    <!-- Mobile Page Header for Non-Live Products -->
    <header class="page-header product fixie non-live" v-if="!(product.isStock || product.isLive)">
      <div class="wrapper">
        <div class="title">
          <h1>{{ product.title }}</h1>
          <h3>
            <span class="by">By</span>
            <a :href="product.designer.url">{{ product.designer.name }}</a>
          </h3>
        </div>
      </div>
    </header>

    <!-- Page Header Proper, Shown at Desktop Sizes -->
    <header class="page-header product">
      <div class="wrapper">
        <div class="title">
          <h1>{{ product.title }}</h1>
          <h3>
            <span>By</span>
            <a :href="product.designer.url">{{ product.designer.name }}</a>
          </h3>
        </div>
        <aside>
          <!-- Product Type Options, Hidden on Mobile, Hidden When 1 or Fewer Exist -->
          <!-- <product-choice
          v-for="(choice, choiceIndex) in activeChoices"
          v-if="choiceIndex === 0 && showChoice(choiceIndex) && choice.options.length >= 2"
          :key="choice.name"
          :product="product"
          :choice="choice"
          :choiceIndex="choiceIndex"
          :selected-option="choice.selectedOption"
          :showLabel="false"
          :userMadeFinalChoice="userMadeFinalChoice"
          @view-size-chart="viewSizeChart"
          @select-option="selectOption" >
        </product-choice> -->

          <!-- Campaign Stats, Shown When 1 or Fewer Type Option Exist on Live Products -->
          <!-- Lifetime Stats, Shown When 1 or Fewer Type Option Exist on Expired Products -->
          <product-stats :product="product" :showGoal="!isSellerStore" v-if="showChoice(0) && activeChoices[0].options.length <= 1 && product.isPreOrder"></product-stats>
        </aside>
      </div>
    </header>

    <section
      class="product-block"
      :class="{
        whiteout:
          (selectedVariant.iconColor === '#ffffff' || selectedVariant.iconColor === '#f0f0f3' || selectedVariant.iconColor === 'WhiteFleck') &&
          product.designer.id != '101930' &&
          product.type != 'drinkware',
        'on-demand': product.isOnDemand,
      }"
    >
      <div class="watermark">
        {{ product.title }}
      </div>

      <!-- Store Campaign Product Header -->
      <header class="store-campaign-header" v-if="isSellerStore">
        <div class="wrapper">
          <div class="title">
            <h1>{{ product.title }}</h1>
          </div>
          <aside>
            <!-- Product Type Options, Hidden on Mobile, Hidden When 1 or Fewer Exist -->
            <!-- <product-choice
            v-for="(choice, choiceIndex) in activeChoices"
            v-if="choiceIndex === 0 && showChoice(choiceIndex) && choice.options.length >= 2"
            :key="choice.name"
            :product="product"
            :choice="choice"
            :choiceIndex="choiceIndex"
            :selected-option="choice.selectedOption"
            :showLabel="false"
            :userMadeFinalChoice="userMadeFinalChoice"
            @view-size-chart="viewSizeChart"
            @select-option="selectOption" >
          </product-choice> -->

            <!-- Campaign Stats, Shown When 1 or Fewer Type Option Exist on Live Products -->
            <!-- Lifetime Stats, Shown When 1 or Fewer Type Option Exist on Expired Products -->
            <product-stats :product="product" :showGoal="!isSellerStore" v-if="showChoice(0) && activeChoices[0].options.length <= 1 && product.isPreOrder"></product-stats>
          </aside>
        </div>
      </header>

      <div class="wrapper">
        <product-carousel :images="carouselImages" :videos="carouselVideos" :models="carouselModels" :staticImages="carouselStaticImages"></product-carousel>

        <aside>
          <div
            class="purchase-form"
            :class="{
              expired: product.isExpired || (product.isStock && product.isSoldOut),
            }"
          >
            <!-- Type Toggle, Mobile Only -->
            <!-- <div class="wrapper mobile-type-toggle">
            <product-choice
              v-for="(choice, choiceIndex) in activeChoices"
              v-if="choiceIndex === 0 && showChoice(choiceIndex) && choice.options.length >= 2"
              :key="choice.name"
              :product="product"
              :choice="choice"
              :choiceIndex="choiceIndex"
              :selected-option="choice.selectedOption"
              :userMadeFinalChoice="userMadeFinalChoice"
              @view-size-chart="viewSizeChart"
              @select-option="selectOption" >
            </product-choice>
          </div> -->

            <!-- Choices -->
            <template v-for="(choice, choiceIndex) in activeChoices">
              <product-choice
                v-if="((activeChoices.length > 1 && choiceIndex === 0 && choice.options.length >= 2) || activeChoices.length <= 1 || choiceIndex > 0) && showChoice(choiceIndex)"
                :key="choice.name"
                :product="product"
                :choice="choice"
                :choiceIndex="choiceIndex"
                :selected-option="choice.selectedOption"
                :userMadeFinalChoice="userMadeFinalChoice"
                @view-size-chart="viewSizeChart"
                @select-option="selectOption"
              ></product-choice>
            </template>

            <!-- Disclaimers -->
            <div class="product-disclaimer-wrapper">
              <div
                class="product-disclaimer product-disclaimer--caution"
                :class="{
                  active: product.publishingStatus === 'onboarding' && product.isPreOrder,
                }"
              >
                <figure>
                  <span>!</span>
                </figure>
                <figcaption>
                  <p>
                    This campaign product is currently
                    <strong>pre-launch</strong>
                    . As the logged-in creator of this product, you are the only person who can see it.
                  </p>
                </figcaption>
              </div>
            </div>

            <template v-if="(product.isStock && !product.isSoldOut && !isDisabledLegacyClockwiseOnDemandProduct) || product.isLive">
              <div class="product-disclaimer-wrapper">
                <div
                  class="product-disclaimer"
                  :class="{
                    active: selectedVariant.isBackorder || [102505].includes(product.id),
                  }"
                >
                  <figure>
                    <span>!</span>
                  </figure>
                  <figcaption>
                    <p>This item is currently in production.</p>
                  </figcaption>
                </div>

                <div
                  class="product-disclaimer"
                  :class="{
                    active: selectedVariant.manufacturer === 'gildan' && selectedVariant.code === '2000',
                  }"
                >
                  <figure>
                    <span>!</span>
                  </figure>
                  <figcaption>
                    <p>
                      This size is printed on a heavyweight Gildan tee. Please check our
                      <a @click.prevent="viewSizeChart" href="#">size chart and product details</a>
                      for more information.
                    </p>
                  </figcaption>
                </div>

                <div
                  class="product-disclaimer"
                  :class="{
                    active: selectedVariant.manufacturer === 'next level' && selectedVariant.sex === 'women',
                  }"
                >
                  <figure>
                    <span>!</span>
                  </figure>
                  <figcaption>
                    <p>
                      Our junior fit tees fit like, well, junior fit tees. Please check our
                      <a @click.prevent="viewSizeChart" href="#">size chart</a>
                      to ensure a good fit.
                    </p>
                  </figcaption>
                </div>

                <div class="product-disclaimer" :class="{ active: selectedVariant.productId == 21145 }">
                  <figure>
                    <span>!</span>
                  </figure>
                  <figcaption>
                    <p>This product is not available for international shipping. Standard discount codes may not apply.</p>
                  </figcaption>
                </div>

                <div
                  class="product-disclaimer holiday-shipping-yes"
                  :class="{
                    active: selectedVariant.willArriveByChristmas !== null && selectedVariant.willArriveByChristmas,
                  }"
                >
                  <figure>
                    <symbol-icon icon-name="tree" view-box="0 0 49.8 72" classes="Icon--colorDarkGreen" :has-texture="true" />
                  </figure>
                  <figcaption>
                    <p>
                      <strong>Get it in time for Christmas!</strong>
                      There’s an excellent chance this product arrives before Dec. 25. (U.S. customers only.)
                    </p>
                  </figcaption>
                </div>

                <div
                  class="product-disclaimer holiday-shipping-no"
                  :class="{
                    active: selectedVariant.willArriveByChristmas !== null && !selectedVariant.willArriveByChristmas,
                  }"
                >
                  <figure>
                    <symbol-icon icon-name="tree" view-box="0 0 49.8 72" classes="Icon--colorDarkRed" :has-texture="true" />
                  </figure>
                  <figcaption>
                    <p>
                      <strong>Warning!</strong>
                      This product is subject to our holiday shipping schedule. Items may not arrive before Dec. 25.
                    </p>
                  </figcaption>
                </div>

                <div
                  class="product-disclaimer product-disclaimer--caution"
                  :class="{
                    active: product.publishingStatus === 'unpublished',
                  }"
                >
                  <figure>
                    <span>!</span>
                  </figure>
                  <figcaption>
                    <p>
                      This product is currently
                      <strong>unpublished</strong>
                      . As the logged-in creator of this product, you are the only person who can see and purchase it.
                    </p>
                  </figcaption>
                </div>
              </div>

              <div class="buy" :class="{ 'l-sale': retailPrice !== discountedPrice }">
                <div v-if="retailPrice !== discountedPrice" class="price sale">
                  <div class="price-wrapper">
                    <div class="standard">
                      <span class="symbol">$</span>
                      {{ retailPrice }}
                    </div>
                    <div class="discounted">
                      <span class="symbol">$</span>
                      {{ discountedPrice }}
                    </div>
                  </div>
                </div>
                <div v-else class="price">
                  <div class="price-wrapper">
                    <span class="symbol">$</span>
                    {{ retailPrice }}
                  </div>
                </div>
                <button class="buy-button" :disabled="isSubmitting || !selectedVariant.availableForSale || !userMadeFinalChoice" @click.prevent.stop="addToBag" :class="{ submitting: isSubmitting }">
                  <span v-show="!isSubmitting">Add to Cart</span>
                  <VueSpinner v-show="isSubmitting" color="#ff523f" />
                </button>
              </div>

              <product-stats
                :product="product"
                :showGoal="!isSellerStore"
                v-if="product.isPreOrder"
                :class="{
                  'u-hideAboveMobile': activeChoices[0].options.length <= 1,
                }"
              ></product-stats>

              <div class="campaign-info" :class="{ expired: product.isPreOrder && product.isExpired }">
                <div class="campaign-notice">
                  <template v-if="product.isPreOrder && product.preorderStatus === 'live'">
                    <p>
                      The last time to buy this is
                      <strong>
                        {{ toLocaleString(product.dates.expiresAt, "DATETIME_FULL") }}
                      </strong>
                      . Orders usually ship within
                      {{ product.dates.fullShipping.relativeRangeFormatted }} of the end of the campaign (
                      <i>{{ product.dates.fullShipping.rangeFormatted }}</i>
                      ).
                      <a href="https://support.cottonbureau.com/article/32-when-will-i-get-my-order">Learn More...</a>
                    </p>
                    <product-reminder v-if="showReminder" :product="product"></product-reminder>
                  </template>
                  <p v-else-if="selectedVariant.subscriptions && selectedVariant.subscriptions.length">
                    If you place a subscription order today (or any time before
                    {{ toLocaleString(currentSubscription().cloneAfter, { month: "short", day: "numeric" }) }}), your first journal will ship within
                    {{ selectedVariant.fullShipping.relativeRangeFormatted }}
                    ({{ selectedVariant.fullShipping.rangeFormatted }}), and your second journal will ship in time for the beginning of the next quarter ({{
                      toLocaleString(currentSubscription().dueBy, { month: "short", day: "numeric" })
                    }}).
                  </p>
                  <p v-else>
                    <template v-if="selectedVariant.isBackorder || [102505].includes(product.id)">
                      <template v-if="[102505].includes(product.id)">Orders expected to ship in mid May.</template>
                      <template v-else>
                        Orders expected to ship by
                        <i>{{ selectedVariant.fullShipping.rangeFormatted }}</i>
                        .
                      </template>
                      <a href="https://support.cottonbureau.com/article/32-when-will-i-get-my-order">Learn More...</a>
                    </template>
                    <template v-else>
                      Orders usually ship within
                      {{ selectedVariant.fullShipping.relativeRangeFormatted }}
                      (
                      <i>{{ selectedVariant.fullShipping.rangeFormatted }}</i>
                      ).
                      <a href="https://support.cottonbureau.com/article/32-when-will-i-get-my-order">Learn More...</a>
                    </template>
                  </p>
                </div>
              </div>
            </template>
          </div>

          <!-- Expired -->
          <template v-if="(product.isPreOrder && product.isExpired) || (product.isStock && product.isSoldOut)">
            <product-request v-if="(product.isPreOrder && product.isExpired) || (product.isStock && product.isSoldOut)" :product="product" />

            <!-- Show When There is Less Than 2 Type Options, Otherwise it Shows Up in the Header -->
            <product-stats
              :product="product"
              :showGoal="!isSellerStore"
              :class="{
                'u-hideAboveMobile': activeChoices[0].options.length <= 1,
              }"
            ></product-stats>

            <!--
          <section class="product-content">
            <div class="product-info">
              <div class="wrapper">
                <div class="description">
                  <h6>Description</h6>
                  <div class="text">
                    <p v-html="$sanitize(product.description)"></p>
                  </div>
                </div>
                <div class="actions">
                  <div class="tags">
                    <h6>Tags</h6>
                    <div class="tag-list">
                      <a v-for="(tag, tagIndex) in product.tags" :href="tag.url" class="tag">{{ tag.name }}</a>
                    </div>
                  </div>
                  <div class="share">
                    <h6>Share</h6>
                    <div class="link-list">
                      <a :href="socialUrls.pinterest"
                      class="share-link"
                      @click.prevent="triggerShare('pinterest', $event)">
                        <symbol-icon
                          icon-name="pinterest"
                          icon-suffix="circle"
                          class="icon"
                          view-box="0 0 71.381 71.382" />
                      </a>
                      <a :href="socialUrls.facebook"
                      class="share-link"
                      @click.prevent="triggerShare('facebook', $event)">
                        <symbol-icon
                          icon-name="facebook"
                          class="icon"
                          view-box="0 0 72 72" />
                      </a>
                      <a :href="socialUrls.twitter"
                      class="share-link"
                      @click.prevent="triggerShare('twitter', $event)">
                        <symbol-icon
                          icon-name="twitter"
                          class="icon"
                          view-box="0 0 87.844 71.388" />
                      </a>
                      <span class="url-link"><a :href="socialUrls.product" v-clipboard:copy="socialUrls.product" @click.prevent>Page Link</a></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="creator" v-if="!isSellerStore">
              <div class="wrapper">
                <header>
                  <a :href="product.designer.url"><figure class="avatar" :style="{'background-image': `url(${product.designer.avatarUrl})`}"></figure></a>
                  <h3><a :href="product.designer.url">{{ product.designer.name }}</a></h3>
                  <h5>{{ product.designer.location }}</h5>
                </header>
                <div class="bio">
                  <p>{{ product.designer.bio }}</p>
                </div>
                <div class="links">
                  <a v-if="product.designer.twitter"
                  :href="'https://twitter.com/' + encodeURIComponent(product.designer.twitter)">
                    <symbol-icon
                    icon-name="twitter"
                    class="icon"
                    view-box="0 0 87 71" />
                  </a>
                  <a v-if="product.designer.instagram"
                  :href="'https://www.instagram.com/' + encodeURIComponent(product.designer.instagram)">
                    <symbol-icon
                    icon-name="instagram"
                    class="icon"
                    view-box="0 0 72 72" />
                  </a>
                  <a v-if="product.designer.web"
                  :href="'http://' + product.designer.web">
                    <symbol-icon
                    icon-name="world"
                    class="icon"
                    view-box="0 0 71.957 71.957" />
                  </a>
                </div>
              </div>
            </div>
          </section>
          --></template>

          <template v-if="isDisabledLegacyClockwiseOnDemandProduct">
            <div class="product-disclaimer-wrapper">
              <div class="product-disclaimer active">
                <figure>
                  <span>!</span>
                </figure>
                <figcaption>
                  <p>
                    This product is not currently available. Please email
                    <a href="mailto:support@cottonbureau.com">support@cottonbureau.com</a>
                    if you would like to see it come back.
                  </p>
                </figcaption>
              </div>
            </div>
          </template>
          <template v-if="user.id == product.designer.id && product.isOnDemandV2 && product.type === 'clothing'">
            <div class="product-disclaimer-wrapper product-disclaimer-wrapper--convert">
              <div class="product-disclaimer active">
                <figure>
                  <span>→</span>
                </figure>
                <figcaption>
                  <p>
                    Did you know Cotton Bureau now has support for on demand phone cases, hats, and totes? You can use the artwork from this product to
                    <a :href="createFromProductUrl()">get started</a>
                    .
                  </p>
                </figcaption>
              </div>
            </div>
          </template>
        </aside>
      </div>
    </section>

    <section class="store-product-content" v-if="isSellerStore" :class="{ expired: !product.isLive }">
      <!-- Store Products Only -->
      <div class="wrapper">
        <div class="other-products">
          <header>
            <h4>Check These Out Too</h4>
          </header>

          <div class="wrapper">
            <a v-for="(related, productIndex) in relatedProducts" :href="related.links.url" class="product-card">
              <figure>
                <ProductImageV2 :productId="related.id" :default="true" :poster="related.salesMethod === 'stock'" :hash="related.imageCacheHash" sizes="320px" />
              </figure>
              <figcaption>
                <h4>{{ related.title }}</h4>
                <h6>{{ related.types.join(" / ") }}</h6>
                <div class="campaign-info">
                  <div class="sales" v-if="related.isPreOrder">
                    <symbol-icon icon-name="graph-stroke" class="icon" view-box="0 0 24 24" />
                    <template v-if="related.isLive">
                      <strong>
                        {{ related.stats.sold.toLocaleString() }}
                      </strong>
                      <span class="label">Sold</span>
                    </template>
                    <template v-else>
                      <strong>
                        {{ related.stats.lifetimeSold.toLocaleString() }}
                      </strong>
                      <span class="label">Lifetime Sold</span>
                    </template>
                  </div>
                  <div class="time" v-if="related.isLive">
                    <symbol-icon icon-name="clock-stroke" class="icon" view-box="0 0 24 24" />
                    <strong>{{ related.stats.timeLeft.value }}</strong>
                    <span class="label">{{ related.stats.timeLeft.unit }}</span>
                  </div>
                </div>
              </figcaption>
            </a>
          </div>
        </div>

        <div class="product-info">
          <div class="wrapper">
            <div class="description" v-if="product.description.length">
              <h6>Description</h6>
              <div class="text" v-if="product.description.length">
                <p v-dompurify-html="product.description"></p>
              </div>
              <div v-else class="text text--empty">
                <p>No product description available. You’ll have to use your imagination.</p>
              </div>
            </div>
            <div class="actions">
              <div class="tags" v-if="product.tags.length">
                <h6>Tags</h6>
                <div class="tag-list">
                  <a v-for="(tag, tagIndex) in product.tags" :href="tag.url" class="tag">
                    {{ tag.name }}
                  </a>
                </div>
              </div>
              <div class="share">
                <h6>Share</h6>
                <div class="link-list">
                  <a :href="socialUrls.pinterest" class="share-link" @click.prevent="triggerShare('pinterest', $event)">
                    <symbol-icon icon-name="pinterest" icon-suffix="circle" class="icon" view-box="0 0 71.381 71.382" />
                  </a>
                  <a :href="socialUrls.facebook" class="share-link" @click.prevent="triggerShare('facebook', $event)">
                    <symbol-icon icon-name="facebook" class="icon" view-box="0 0 72 72" />
                  </a>
                  <a :href="socialUrls.bluesky" class="share-link" @click.prevent="triggerShare('bluesky', $event)">
                    <symbol-icon icon-name="bluesky" class="icon icon--bluesky" view-box="0 0 72 72" />
                  </a>
                  <span class="url-link">
                    <a :href="socialUrls.product" v-on:click="onCopy(socialUrls.product)" @click.prevent>Copy URL</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--
  <section class="product-content" v-if="!isSellerStore && (product.isStock || product.isLive)">
  -->
    <section class="product-content" v-if="!isSellerStore">
      <div class="wrapper">
        <div class="product-info">
          <div class="wrapper">
            <div class="description">
              <h6>Description</h6>
              <div class="text" v-if="product.description.length">
                <p v-dompurify-html="product.description"></p>
              </div>
              <div v-else class="text text--empty">
                <p>No product description available. You’ll have to use your imagination.</p>
              </div>
            </div>
            <div class="actions">
              <div class="tags" v-if="product.tags.length">
                <h6>Tags</h6>
                <div class="tag-list">
                  <a v-for="(tag, tagIndex) in product.tags" :href="tag.url" class="tag">
                    {{ tag.name }}
                  </a>
                </div>
              </div>
              <div class="share">
                <h6>Share</h6>
                <div class="link-list">
                  <a :href="socialUrls.pinterest" class="share-link" @click.prevent="triggerShare('pinterest', $event)">
                    <symbol-icon icon-name="pinterest" icon-suffix="circle" class="icon" view-box="0 0 71.381 71.382" />
                  </a>
                  <a :href="socialUrls.facebook" class="share-link" @click.prevent="triggerShare('facebook', $event)">
                    <symbol-icon icon-name="facebook" class="icon" view-box="0 0 72 72" />
                  </a>
                  <a :href="socialUrls.bluesky" class="share-link" @click.prevent="triggerShare('bluesky', $event)">
                    <symbol-icon icon-name="bluesky" class="icon icon--bluesky" view-box="0 0 72 72" />
                  </a>
                  <span class="url-link">
                    <a :href="socialUrls.product" v-on:click="onCopy(socialUrls.product)" @click.prevent>Copy URL</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="creator">
          <div class="wrapper">
            <header>
              <a :href="product.designer.url">
                <figure
                  v-if="product.designer.avatarUrl"
                  class="avatar"
                  :style="{
                    'background-image': `url(${product.designer.avatarUrl})`,
                  }"
                ></figure>
                <figure v-else class="avatar avatar--default"><symbol-icon icon-name="uiUser" view-box="0 0 24 24" /></figure>
              </a>
              <h3>
                <a :href="product.designer.url">{{ product.designer.name }}</a>
              </h3>
              <h5>{{ product.designer.location }}</h5>
            </header>
            <div class="bio">
              <p>{{ product.designer.bio }}</p>
            </div>
            <div class="links">
              <template v-for="(social, socialKey) in product.designer.formattedSocials" :key="socialKey">
                <a :class="[social.class]" :href="social.url" rel="me">
                  <symbol-icon class="icon" :icon-name="social.icon.name" :view-box="social.icon.viewBox" />
                </a>
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cross-sell" v-if="!isSellerStore">
      <div class="pattern"></div>

      <div class="related">
        <header>
          <h4>Check These Out Too</h4>
          <span class="line"><i></i></span>
        </header>

        <div class="card-strip">
          <div class="card-strip-mask">
            <div class="card-strip-wrapper">
              <div class="card-row">
                <a v-for="(related, productIndex) in relatedProducts" :href="related.links.url" class="product-card">
                  <figure>
                    <div class="product-card-background">
                      <ProductImageV2 :productId="related.id" :detail="true" :poster="related.salesMethod === 'stock'" :hash="related.imageCacheHash" sizes="160px" :imgixParams="productCardBackgrounImgixParams" />
                    </div>
                    <div class="product-card-item" :class="related.type">
                      <ProductImageV2 :productId="related.id" :default="true" :poster="related.salesMethod === 'stock'" :hash="related.imageCacheHash" sizes="160px" />
                    </div>
                  </figure>
                  <figcaption>
                    <h4>{{ related.title }}</h4>
                    <h6 class="types">{{ related.types.join(" / ") }}</h6>
                    <div class="campaign-info">
                      <div class="sales" v-if="related.isPreOrder">
                        <symbol-icon icon-name="graph-stroke" class="icon" view-box="0 0 24 24" />
                        <template v-if="related.isLive">
                          <strong>
                            {{ related.stats.sold.toLocaleString() }}
                          </strong>
                          <span class="label">Sold</span>
                        </template>
                        <template v-else>
                          <strong>
                            {{ related.stats.lifetimeSold.toLocaleString() }}
                          </strong>
                          <span class="label">Lifetime Sold</span>
                        </template>
                      </div>
                      <div class="time" v-if="related.isLive">
                        <symbol-icon icon-name="clock-stroke" class="icon" view-box="0 0 24 24" />
                        <strong>{{ related.stats.timeLeft.value }}</strong>
                        <span class="label">
                          {{ related.stats.timeLeft.unit }}
                        </span>
                      </div>
                    </div>
                  </figcaption>
                </a>

                <div class="spacer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--
      <div class="collections">
          <header>
              <h4>Related Collections</h4>
              <span class="line"><i></i></span>
          </header>
          <div class="featured">
              <div class="collection-strip">
                  <a href="#" class="collection-card Outdoorsy">
                      <figure>
                          <div class="image"></div>
                          <symbol-icon
                          icon-name="clock-stroke"
                          class="icon"
                          view-box="0 0 24 24" />
                      </figure>
                      <figcaption>
                          <h4>Outdoorsy</h4>
                          <span class="amount">123</span>
                      </figcaption>
                  </a>
                  <a href="#" class="collection-card Outdoorsy">
                      <figure>
                          <div class="image"></div>
                          <symbol-icon
                          icon-name="clock-stroke"
                          class="icon"
                          view-box="0 0 24 24" />
                      </figure>
                      <figcaption>
                          <h4>Outdoorsy</h4>
                          <span class="amount">123</span>
                      </figcaption>
                  </a>
                  <a href="#" class="collection-card Outdoorsy">
                      <figure>
                          <div class="image"></div>
                          <symbol-icon
                          icon-name="clock-stroke"
                          class="icon"
                          view-box="0 0 24 24" />
                      </figure>
                      <figcaption>
                          <h4>Outdoorsy</h4>
                          <span class="amount">123</span>
                      </figcaption>
                  </a>
              </div>
          </div>
          <div class="tags">
              <div class="tag-list">
                  <a href="#" class="tag">Top Pun</a>
                  <a href="#" class="tag">Top Pun</a>
                  <a href="#" class="tag">Top Pun</a>
                  <a href="#" class="tag">Top Pun</a>
                  <a href="#" class="tag">Top Pun</a>
              </div>
          </div>
      </div>
      -->
    </section>

    <section class="apparel-resources" v-if="['clothing', 'phonecase', 'hat', 'tote', 'drinkware'].includes(product.type) && /* Mystery Tee */ product.id != 2002">
      <header>
        <div class="wrapper">
          <div class="preface">
            <h4>
              <span class="title">Find Your {{ findYour }}</span>
              <span class="line"><i></i></span>
            </h4>
            <article>
              <h3>{{ selectedBlank.title }}</h3>
              <div class="dropdown-nav-container">
                <select class="dropdown-nav" v-model="selectedBlankIndex">
                  <option v-for="(blank, blankIndex) in processedBlankDetails" :value="blankIndex">
                    {{ blank.title }}
                  </option>
                </select>
              </div>
              <div class="text">
                <p></p>
              </div>
            </article>
          </div>
          <div class="navigation">
            <nav class="sub-nav">
              <ul>
                <li v-for="(blank, blankIndex) in processedBlankDetails">
                  <a href="#" :class="{ active: selectedBlankIndex === blankIndex }" @click.prevent="selectedBlankIndex = blankIndex">
                    {{ blank.title }}
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
      <main>
        <div class="sizing" v-if="product.type === 'clothing'">
          <h6>Sizing</h6>
          <div class="size-chart">
            <div class="size-chart-table" :class="sizeChartTableClass">
              <!-- Headings -->
              <div class="title cell heading"><span>In Inches</span></div>
              <div v-if="hasChest" class="title cell">Chest</div>
              <div v-if="hasLength" class="title cell">Length</div>
              <div v-if="hasSleeve" class="title cell">Sleeve</div>
              <div v-if="hasWaist" class="title cell">Waist</div>

              <template v-for="(size, index) in selectedBlank.sizing.sizes">
                <div class="cell heading" :class="{ zebra: isEvenRow(index) }">
                  <h4>{{ size.label }}</h4>
                </div>
                <div v-if="hasChest" class="cell" :class="{ zebra: isEvenRow(index) }">
                  {{ size.chest }}
                </div>
                <div v-if="hasLength" class="cell" :class="{ zebra: isEvenRow(index) }">
                  {{ size.length }}
                </div>
                <div v-if="hasSleeve" class="cell" :class="{ zebra: isEvenRow(index) }">
                  {{ size.sleeve }}
                </div>
                <div v-if="hasWaist" class="cell" :class="{ zebra: isEvenRow(index) }">
                  {{ size.waist }}
                </div>
              </template>
            </div>
          </div>
          <!-- <div class="models">
            <h6>Product Photography</h6>
            <div class="model-grid womens-tri-blend count-5">
              <figure class="caitlin tri">
                <div class="image"></div>
                <figcaption>Caitlin is 5’7”, 36D bra, wearing a Women’s L.</figcaption>
              </figure>
              <figure class="krystal tri">
                <div class="image"></div>
                <figcaption>Krystal is 5’4”, 34DD bra, wearing a Women’s M.</figcaption>
              </figure>
              <figure class="stacey tri">
                <div class="image"></div>
                <figcaption>Stacey is 5’4”, 40D bra, wearing a Women’s XL.</figcaption>
              </figure>
              <figure class="sam-c tri">
                <div class="image"></div>
                <figcaption>Sam C. is 5’5”, 36C bra, wearing a Women’s M.</figcaption>
              </figure>
              <figure class="katie tri">
                <div class="image"></div>
                <figcaption>Katie is 5’7”, wearing a Women’s 2X.</figcaption>
              </figure>
            </div>
          </div> -->
        </div>
        <div class="about-product" v-else>
          <h6>About This Product</h6>
          <div class="about-product-text">
            <div class="Text">
              <p v-if="product.type === 'phonecase'">
                High quality, no-nonsense cases that get the job done. Light-weight and form-fitting. Sturdy yet svelte. Beautifully designed with easy access to all ports. Printed in the United
                States of America. Not for the faint of heart.
              </p>
              <p v-if="product.type === 'hat'">
                Premium materials, excellent craftsmanship. These hats work hard and last long. Don’t leave home without one. Embroidered in Pittsburgh, Pennsylvania.
              </p>
              <p v-if="product.type === 'tote'">
                Fabric bags made from 100% cotton canvas material. Useful and reusable for years to come. Fits 24 cans of your favorite beverage without breaking a sweat. Construction that won’t quit
                before you do.
              </p>
              <p v-if="product.type === 'drinkware'">
                Doctors say to drink at least 10 cups of water per day. We say, who needs water when you can drink other stuff? We’re not doctors though. Cotton Bureau drinkware is sure to keep your
                beverages hot (or cold), just the way you like them. And you’ll look good too.
              </p>
            </div>
          </div>
        </div>
        <div class="details" v-if="product.type === 'phonecase'">
          <div class="detail-list">
            <h6>Details</h6>
            <ul>
              <li>
                <symbol-icon :icon-name="mapIconTemplate('swatch')" class="icon" view-box="0 0 18 18" />
                <template v-if="selectedBlank.caseType.includes('Tough')">Polycarbonate exterior, TPU liner</template>
                <template v-else-if="selectedBlank.caseType.includes('Slim')">Polycarbonate exterior</template>
                <template v-else-if="selectedBlank.caseType.includes('Clear')">Soft-feel plastic</template>
              </li>
              <li>
                <symbol-icon :icon-name="mapIconTemplate('fit')" class="icon" view-box="0 0 18 18" />
                <template v-if="selectedBlank.caseType.includes('Tough')">Rugged and ready for adventure</template>
                <template v-else-if="selectedBlank.caseType.includes('Slim')">Discreet, sits easily in the pocket</template>
                <template v-else-if="selectedBlank.caseType.includes('Clear')">Nothing to hide, show off what’s inside</template>
              </li>
              <li>
                <symbol-icon :icon-name="mapIconTemplate('ink')" class="icon" view-box="0 0 18 18" />
                <template v-if="selectedBlank.caseType.includes('Tough')">In-surface print, resists scratching, peeling, and fading</template>
                <template v-else-if="selectedBlank.caseType.includes('Slim')">In-surface print, resists scratching, peeling, and fading</template>
                <template v-else-if="selectedBlank.caseType.includes('Clear')">UV-printed</template>
              </li>
              <li>
                <symbol-icon :icon-name="mapIconTemplate('location')" class="icon" view-box="0 0 18 18" />
                Made in the U.S.A.
              </li>
              <li v-for="(metadata, index) in product.metadata.filter((m) => m.public)">
                <symbol-icon :icon-name="mapIconTemplate(metadata.iconTemplate)" class="icon" view-box="0 0 18 18" />
                {{ metadata.value }}
              </li>
            </ul>
          </div>
        </div>
        <div class="details" v-else>
          <div class="detail-list">
            <h6>Details</h6>
            <ul>
              <li v-for="(metadata, index) in selectedBlank.metadata">
                <template v-if="metadata.key !== 'notes'">
                  <symbol-icon :icon-name="mapIconTemplate(metadata.iconTemplate)" class="icon" view-box="0 0 18 18" />
                  {{ metadata.value }}
                </template>
              </li>
              <li v-for="(metadata, index) in product.metadata.filter((m) => m.public)">
                <symbol-icon :icon-name="mapIconTemplate(metadata.iconTemplate)" class="icon" view-box="0 0 18 18" />
                {{ metadata.value }}
              </li>
              <li v-if="product.type === 'clothing'">
                <symbol-icon icon-name="detailInk" class="icon" view-box="0 0 18 18" />
                <template v-if="product.isOnDemand">Graphic digitally printed.</template>
                <template v-else>Graphic screen printed.</template>
              </li>
            </ul>
          </div>
          <div class="notes">
            <h6></h6>
            <template v-for="(metadata, index) in selectedBlank.metadata">
              <div v-if="metadata.key === 'notes'" v-html="metadata.value"></div>
            </template>
            <p></p>
          </div>
        </div>
      </main>
    </section>

    <div class="admin-tools" v-if="isAdmin">
      <figure>
        <symbol-icon icon-name="wrenches" class="icon" view-box="0 0 24 24" />
      </figure>
      <div class="links">
        <a :href="editProductUrl">Edit Product</a>
      </div>
    </div>

    <div class="admin-tools" v-if="user.id == product.designer.id">
      <figure>
        <symbol-icon icon-name="wrenches" class="icon" view-box="0 0 24 24" />
      </figure>
      <div class="links">
        <a :href="sellerEditProductUrl">Edit Product</a>
      </div>
    </div>
  </div>
</template>

<script>
const ProductCarousel = defineAsyncComponent(() => import("@/product/components/product-carousel.vue"));
const ProductChoice = defineAsyncComponent(() => import("@/product/components/product-choice.vue"));
const ProductImageV2 = defineAsyncComponent(() => import("@/product/components/product-image-v2.vue"));
const ProductMeter = defineAsyncComponent(() => import("@/product/components/product-meter.vue"));
const ProductReminder = defineAsyncComponent(() => import("@/product/components/product-reminder.vue"));
const ProductRequest = defineAsyncComponent(() => import("@/product/components/product-request.vue"));
const ProductStats = defineAsyncComponent(() => import("@/product/components/product-stats.vue"));
const SymbolIcon = defineAsyncComponent(() => import("@/components/symbol-icon.vue"));
const VueSpinner = defineAsyncComponent(() => import("vue3-spinners"));
import { buildUrl } from "@imgix/vue";
import { DateTime } from "luxon";
import { defineAsyncComponent } from "vue";
import { mapState } from "pinia";
import { useCottonBureauStore } from "@/store/index.js";
import clone from "clone";
import collect from "collect.js";
import qs from "querystringify";
import slugify from "slugify";
import Velocity from "velocity-animate";

const ICON_TEMPLATE_MAP = {
  fit: "detailFit",
  info: "detailInfo",
  location: "detailLocation",
  swatch: "detailMaterial",
  tag: "detailTag",
  ink: "detailInk",
};

const retailPrices = {
  22361: {
    "Retail Price": "12",
  },
  32182: {
    "Retail Price": "35",
  },
  32183: {
    "Retail Price": "35",
  },
  32184: {
    "Retail Price": "60",
  },
};

export default {
  components: {
    ProductCarousel,
    SymbolIcon,
    VueSpinner,
    ProductImageV2,
    ProductReminder,
    ProductRequest,
    ProductMeter,
    ProductStats,
    ProductChoice,
  },

  mixins: [],

  props: {
    product: {
      type: Object,
      required: true,
    },

    relatedProducts: {
      type: Array,
      required: true,
    },

    blankDetails: {
      type: Array,
      required: true,
    },

    isSellerStore: {
      type: Boolean,
      required: true,
    },

    isSubmitting: {
      type: Boolean,
      required: true,
    },

    message: {
      type: [Object, String],
      default: null,
    },

    isAdmin: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      choices: [],
      rootChoice: {},
      selectedBlankIndex: 0,
      selectedVariant: null,
      activeChoices: [],
      selectedOptions: [],
      userMadeFinalChoice: false,
      processedBlankDetails: this.$props.blankDetails,
      productCardBackgrounImgixParams: { q: 1 },
    };
  },

  computed: {
    carouselImages() {
      if (this.selectedVariant) {
        let images = [];

        if (this.product.supportsOnDemandMockups) {
          let label = "undefined";

          if (this.product.type === "clothing") {
            label = String(this.activeChoices?.find((choice) => choice.name === "colorMaterial")?.selectedOption.name);
          } else if (this.product.type === "phonecase") {
            const model = String(this.activeChoices?.find((choice) => choice.name === "model")?.selectedOption.name);
            const phonecase = String(this.activeChoices?.find((choice) => choice.name === "case")?.selectedOption.name);
            label = `${model} ${phonecase}`;
          } else if (this.product.type === "hat") {
            label = String(this.activeChoices?.find((choice) => choice.name === "colorMaterial")?.selectedOption.name);
          } else if (this.product.type === "tote") {
            label = String(this.activeChoices?.find((choice) => choice.name === "colorMaterial")?.selectedOption.name);
          } else if (this.product.type === "drinkware") {
            // const style = String(this.activeChoices?.find((choice) => choice.name === "style")?.selectedOption.name);
            label = "3D Render";
          }

          images.push({
            props: { variantId: this.selectedVariant.id },
            label: label,
          });

          if (this.product.isPreOrder) {
            this.selectedVariant.images.forEach((image, index) => {
              images.push({
                props: { variantId: this.selectedVariant.id, index: index },
                label: image.label,
              });
            });
          } else {
            // For legacy on-demand products with pre-rendered images
            if (this.selectedVariant.images.length > 1) {
              this.selectedVariant.images.slice(1).forEach((image, index) => {
                images.push({
                  props: { variantId: this.selectedVariant.id, index: index + 1 },
                  label: image.label,
                });
              });
            }
          }

          images.push({
            props: { variantId: this.selectedVariant.id, detail: true },
            label: "Detail",
          });

          const detailImages = this.product.images.filter((image) => image.label.search(/detail/i) >= 0);

          if (detailImages.length > 1) {
            detailImages.slice(1).forEach((image, index) => {
              images.push({
                props: { productId: this.product.id, detail: true, index: index + 1 },
                label: image.label,
              });
            });
          }
        } else {
          this.selectedVariant.images.forEach((image, index) => {
            images.push({
              props: { variantId: this.selectedVariant.id, index: index },
              label: image.label,
            });
          });

          const detailImages = this.product.images.filter((image) => image.label.search(/detail/i) >= 0);

          detailImages.forEach((image, index) => {
            images.push({
              props: { productId: this.product.id, detail: true, index: index },
              label: image.label,
            });
          });
        }

        images = images.map((image) => {
          image.props = { ...image.props, hash: this.product.imageCacheHash };
          return image;
        });

        return images;
      } else {
        return [];
      }
    },

    carouselVideos() {
      if (this.selectedVariant && this.selectedVariant.id == 16404980) {
        return [
          {
            videoUrl: "https://www.youtube-nocookie.com/embed/vMpGWDA_ih8",
            thumbnailUrl: "https://img.youtube.com/vi/vMpGWDA_ih8/mqdefault.jpg",
            label: "Sidekick Notepad, Video",
          },
        ];
      } else {
        return [];
      }
    },

    carouselModels() {
      let models = [];

      if (this.selectedVariant?.model3D) {
        const model = this.selectedVariant.model3D;

        const params = {
          vid: this.selectedVariant.id,

          hash: this.product.imageCacheHash,
        };

        const query = qs.stringify(params, true);

        models.push({
          props: { src: model.model.low, artwork: `/mockup/drinkware-texture${query}`, camera: model.camera },
          thumbProps: { variantId: this.selectedVariant.id },
          label: "3D Model",
        });
      }

      models = models.map((model) => {
        model.thumbProps = { ...model.thumbProps, hash: this.product.imageCacheHash };
        return model;
      });

      return models;
    },

    carouselStaticImages() {
      const images = [];

      if (this.selectedVariant) {
        if (this.product.supportsOnDemandMockups) {
          if (this.product.type === "drinkware") {
            let path = null;

            switch (this.selectedVariant.code) {
              case "tA20sSteel":
              case "tR20sWhite":
              case "tR20sBlack":
                path = "drinkware/photography/everyday-tumbler.png";
                break;
              case "gC16":
                path = "drinkware/photography/pint-glass.png";
                break;
              case "wbV20sWhite":
                path = "drinkware/photography/skinny-bottle.png";
                break;
              case "cG16aClear":
                path = "drinkware/photography/straw-cup.png";
                break;
              case "gR10":
                path = "drinkware/photography/rocks-glass.png";
                break;
              case "tK12sWhite":
                path = "drinkware/photography/skinny-koozie.png";
                break;
              case "tB12sWhite":
                break;
            }

            if (path) {
              images.push({
                props: { path: "image", imgixParams: { path: path } },
                label: "Photo",
              });
            }
          }
        }
      }

      return images;
    },

    productData() {
      return {
        id: this.product.id,
        name: this.product.title,
        brand: this.product.designer.name,
      };
    },

    purchaseData() {
      return Object.assign({}, this.productData, {
        price: this.selectedVariant.price,
        variant: this.selectedVariant.id,
        quantity: 1,
      });
    },

    showReminder() {
      const nowPlus36Hours = DateTime.now().plus({ hours: 36 });
      const expiration = DateTime.fromISO(this.product.dates.expiresAt);

      return nowPlus36Hours < expiration;
    },

    retailPrice() {
      if (this.selectedVariant.retailPrice !== null) {
        return this.selectedVariant.retailPrice;
      } else {
        return this.selectedVariant.price;
      }
    },

    discountedPrice() {
      return this.selectedVariant.price;
    },

    // Social Buttons
    socialUrls() {
      const product = this.product;
      const imageUrl = encodeURIComponent(buildUrl("mockup", { pid: product.id, default: 1 }));
      const productUrl = encodeURIComponent(product.links.url);
      const productTitle = encodeURIComponent(product.title);
      const blueskyOrName = encodeURIComponent(product.designer.blueskyOrName);

      let blueskyMsg = `Check it out: “${productTitle}” by ${blueskyOrName} on ` + `@cottonbureau.com — ${productUrl}.`;

      if (product.isPreorder && product.preorderStatus === "live") {
        let timeLeft = product.stats.timeLeft.value + " " + product.stats.timeLeft.unit;

        blueskyMsg += ` Only ${timeLeft} left!`;
      }

      return {
        facebook: `https://www.facebook.com/share.php?u=${productUrl}&title=${productTitle}`,
        pinterest: `//pinterest.com/pin/create/button/?url=${product.links.url}&media=${imageUrl}&` + `description=“${product.title}” designed by ${product.designer.name}. ${product.metaDescription}`,
        bluesky: `https://bsky.app/intent/compose?text=${blueskyMsg}`,
        product: product.links.url,
      };
    },

    // Blank Details
    selectedBlank() {
      return this.processedBlankDetails[this.selectedBlankIndex];
    },

    hasChest() {
      return this.selectedBlank.sizing.hasChestMeasurement;
    },

    hasLength() {
      return this.selectedBlank.sizing.hasLengthMeasurement;
    },

    hasSleeve() {
      return this.selectedBlank.sizing.hasSleeveMeasurement;
    },

    hasWaist() {
      return this.selectedBlank.sizing.hasWaistMeasurement;
    },

    sizeChartTableClass() {
      // + 1 for header row / detail column
      let sizeCount = this.selectedBlank.sizing.sizes.length + 1;
      let measurementCount = this.selectedBlank.sizing.numMeasurements + 1;

      return `col-${measurementCount} row-${sizeCount}`;
    },

    fitDetails() {
      return this.selectedBlank.metadata.find((metadata) => metadata.key === "notes");
    },

    findYour() {
      switch (this.product.type) {
        case "clothing":
          return "Fit";
        case "phonecase":
          return "Case";
        case "hat":
          return "Hat";
        case "tote":
          return "Tote";
        case "drinkware":
          return "Drinkware";
      }
    },

    editProductUrl() {
      return `/admin/edit-product/${this.product.id}`;
    },

    sellerEditProductUrl() {
      return `/account#/products/${this.product.id}`;
    },

    isDisabledLegacyClockwiseOnDemandProduct() {
      return this.product.metadata.some((metadata) => metadata.key === "disabled legacy Clockwise on-demand product");
    },

    ...mapState(useCottonBureauStore, ["user"]),
  },

  watch: {
    selectedVariant: function (newVariant, oldVariant) {
      if (newVariant) {
        let findFunction = (blank) => blank.code === newVariant.code;

        if (this.product.type === "phonecase") {
          findFunction = (blank) => blank.caseType === newVariant.sizeReadable;
        }

        const index = this.processedBlankDetails.findIndex(findFunction);

        if (index >= 0) {
          this.selectedBlankIndex = index;
        }
      }
    },
  },

  created() {
    this.initDataStructure();
  },

  mounted() {
    this.sendAnalyticData();
  },

  methods: {
    buildChoice(variants, depth, keepOptionsIfNone = false) {
      const nextDepth = depth + 1;
      const choice = clone(this.choices[depth]);
      choice.options = this[`${choice.name}Options`](variants);

      if (this.product.isOnDemand && nextDepth < this.choices.length) {
        const filteredOptions = choice.options.filter((option) => option.variants.some((variant) => variant.availableForSale));

        if (keepOptionsIfNone || (depth === 0 && filteredOptions.length === 0)) {
          keepOptionsIfNone = true;
        } else {
          choice.options = filteredOptions;
        }
      }

      const routeSelectedOption = choice.options.find((option) => option.variants.some((variant) => variant.id == this.$route.params.id));
      const defaultSelectedOption = choice.options.find((option) => option.variants.some((variant) => variant.isDefault));
      const firstSelectedOption = choice.options[0];

      let selectedOption = null;

      if (routeSelectedOption) {
        selectedOption = routeSelectedOption;
      } else if (defaultSelectedOption) {
        selectedOption = defaultSelectedOption;
      } else {
        selectedOption = firstSelectedOption;
      }

      choice.selectedOption = selectedOption;

      if (nextDepth < this.choices.length) {
        for (let option of choice.options) {
          option.nextChoice = this.buildChoice(option.variants, nextDepth, keepOptionsIfNone);
        }
      }

      return choice;
    },

    initDataStructure() {
      if (this.product.subscriptions.length) {
        this.choices = [
          {
            name: "colorMaterial",
            title: "Material & Color",
            class: "color",
            showSwatch: true,
            options: [],
          },
          {
            name: "size",
            title: "Type",
            class: "size",
            options: [],
          },
        ];
      } else if (this.product.id == 2002) {
        // Mystery Tees
        this.choices = [
          {
            name: "type",
            title: "Type",
            class: "type",
            options: [],
          },
          {
            name: "fit",
            title: "Fit",
            class: "fit",
            options: [],
          },
          {
            name: "style",
            title: "Style",
            class: "shirt",
            options: [],
          },
          {
            name: "colorMaterial",
            title: "Material & Color",
            class: "color",
            options: [],
          },
          {
            name: "size",
            title: "Size",
            class: "size",
            options: [],
          },
        ];
      } else {
        switch (this.product.type) {
          case "bottle":
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "size",
                options: [],
              },
            ];
            break;
          case "challenge-coin":
            // coin http://cottonbureau.test/products/bartlets-army-challenge-coin
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "size",
                options: [],
              },
            ];
            break;
          case "clothing":
            this.choices = [
              {
                name: "type",
                title: "Type",
                class: "type",
                options: [],
              },
              {
                name: "fit",
                title: "Fit",
                class: "fit",
                showKidsAdultsLink: true,
                options: [],
              },
              {
                name: "style",
                title: "Style",
                class: "shirt",
                showMoreInfoLink: true,
                options: [],
              },
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "size",
                showSizeChartLink: true,
                options: [],
              },
            ];
            break;
          case "drinkware":
            this.choices = [
              {
                name: "type",
                title: "Type",
                class: "type",
                options: [],
              },
              {
                name: "style",
                title: "Style",
                class: "shirt",
                options: [],
              },
              {
                name: "colorMaterial",
                title: "Material",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "size",
                options: [],
              },
            ];
            break;
          case "hat":
            // hat http://cottonbureau.test/products/mkbhd-core-logo-snapback-hat
            this.choices = [
              {
                name: "type",
                title: "Type",
                class: "type",
                options: [],
              },
              {
                name: "fit",
                title: "Fit",
                class: "fit",
                showKidsAdultsLink: true,
                options: [],
              },
              {
                name: "style",
                title: "Style",
                class: "shirt",
                options: [],
              },
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "size",
                options: [],
              },
            ];
            break;
          case "headphones":
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "size",
                options: [],
              },
            ];
            break;
          case "mug":
            // http://cottonbureau.test/products/alcatraz-mug
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "size",
                options: [],
              },
            ];
            break;
          case "notebook":
            // http://cottonbureau.test/products/pocket-notebook-3-pack
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "size",
                options: [],
              },
            ];
            break;
          case "patch":
            // http://cottonbureau.test/products/liftoff-patch
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "size",
                options: [],
              },
            ];
            break;
          case "phonecase":
            this.choices = [
              {
                name: "generation",
                title: "Generation",
                class: "generation",
                options: [],
              },
              {
                name: "model",
                title: "Model",
                class: "model",
                options: [],
              },
              {
                name: "case",
                title: "Case",
                class: "case",
                showMoreInfoLink: true,
                options: [],
              },
              {
                name: "color",
                title: "Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
            ];
            break;
          case "pin":
            // pin http://cottonbureau.test/products/the-west-wing-weekly-lapel-pin
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "shirt",
                options: [],
              },
            ];
            break;
          case "postcard":
            // http://cottonbureau.test/products/criminal-postcards
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "shirt",
                options: [],
              },
            ];
            break;
          case "poster":
            // http://cottonbureau.test/products/criminal-poster
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "shirt",
                options: [],
              },
            ];
            break;
          case "sticker":
            // http://cottonbureau.test/products/criminal-sticker
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "shirt",
                options: [],
              },
            ];
            break;
          case "tote":
            // http://cottonbureau.test/products/tapir-day-tote
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "shirt",
                options: [],
              },
            ];
            break;
          case "wristband":
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "size",
                options: [],
              },
            ];
            break;
          case "metalcard":
            this.choices = [
              {
                name: "size",
                title: "Batch",
                class: "size",
                options: [],
              },
            ];
            break;
          default:
            this.choices = [
              {
                name: "colorMaterial",
                title: "Material & Color",
                class: "color",
                showSwatch: true,
                options: [],
              },
              {
                name: "size",
                title: "Size",
                class: "shirt",
                options: [],
              },
            ];
            break;
        }
      }

      if (this.choices.length) {
        this.rootChoice = this.buildChoice(this.product.variants, 0);
        this.activeChoices[0] = this.rootChoice;
        this.selectOption(0, this.rootChoice.selectedOption, false);
      }

      if (this.product.type === "clothing") {
        for (let variant of this.product.variants) {
          const blank = this.processedBlankDetails.find((blank) => blank.code === variant.code);

          if (blank) {
            if (!("title" in blank)) {
              const name = blank.metadata.find((data) => data.key === "name");

              blank.title = name ? name.value : `${variant.manufacturerReadable} ${variant.materialReadable} ${variant.sexReadable} ${variant.typeReadable}`;
              blank.sizing = {
                hasChestMeasurement: false,
                hasWaistMeasurement: false,
                hasLengthMeasurement: false,
                hasSleeveMeasurement: false,
                numMeasurements: 0,
                sizes: [],
              };
            }

            const hasSize = blank.sizing.sizes.some((size) => size.size === variant.size);

            if (!hasSize) {
              blank.sizing.sizes.push({
                label: variant.sizeReadable,
                size: variant.size,
                chest: variant.chest,
                waist: variant.waist,
                length: variant.length,
                sleeve: variant.sleeve,
              });
            }

            blank.sizing.hasChestMeasurement = blank.sizing.hasChestMeasurement || variant.chest != "";
            blank.sizing.hasWaistMeasurement = blank.sizing.hasWaistMeasurement || variant.waist != "";
            blank.sizing.hasLengthMeasurement = blank.sizing.hasLengthMeasurement || variant.length != "";
            blank.sizing.hasSleeveMeasurement = blank.sizing.hasSleeveMeasurement || variant.sleeve != "";

            blank.sizing.numMeasurements = blank.sizing.hasChestMeasurement ? 1 : 0;
            blank.sizing.numMeasurements += blank.sizing.hasWaistMeasurement ? 1 : 0;
            blank.sizing.numMeasurements += blank.sizing.hasLengthMeasurement ? 1 : 0;
            blank.sizing.numMeasurements += blank.sizing.hasSleeveMeasurement ? 1 : 0;
          }
        }
      } else if (this.product.type === "phonecase") {
        for (let variant of this.product.variants) {
          const blank = this.processedBlankDetails.find((blank) => blank.code === variant.code);

          if (blank) {
            if (!("title" in blank)) {
              blank.title = `${variant.sizeReadable} case`;
            }

            if (!("caseType" in blank)) {
              blank.caseType = variant.sizeReadable;
            }
          }
        }

        this.processedBlankDetails = collect(this.processedBlankDetails).unique("caseType").all();
      } else if (this.product.type === "hat") {
        for (let variant of this.product.variants) {
          const blank = this.processedBlankDetails.find((blank) => blank.code === variant.code);

          if (blank) {
            if (!("title" in blank)) {
              blank.title = variant.typeReadable;
            }
          }
        }
      } else if (this.product.type === "drinkware") {
        for (let variant of this.product.variants) {
          const blank = this.processedBlankDetails.find((blank) => blank.code === variant.code);

          if (blank) {
            if (!("title" in blank)) {
              if (variant.sexReadable === "Everyday Tumbler") {
                blank.title = `${variant.sexReadable} — ${variant.colorReadable}`;
              } else {
                blank.title = variant.sexReadable;
              }
            }
          }
        }
      }
    },

    generationOptions(consideredVariants) {
      const options = [];

      const optionTemplate = {
        name: "",
        variants: [],
      };

      switch (this.product.type) {
        case "phonecase":
          {
            consideredVariants = collect(consideredVariants);

            const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
              return variant.material;
            });

            for (let group in groupedConsideredVariants.all()) {
              const variants = groupedConsideredVariants.get(group);
              const option = clone(optionTemplate);
              const firstVariant = variants.first();
              option.name = firstVariant.materialReadable;
              option.variants = variants.all();
              options.push(option);
            }
          }
          break;
        default:
          {
            const option = clone(optionTemplate);
            option.name = "Generic Item";
            option.variants = consideredVariants.slice();
            options.push(option);
          }
          break;
      }

      const sortOrder = ["iPhone 16", "iPhone 15", "iPhone 14", "iPhone 13", "iPhone 12", "Galaxy S24", "Galaxy S23", "Galaxy S22"];

      options.sort((a, b) => {
        const aIndex = sortOrder.indexOf(a.name);
        const bIndex = sortOrder.indexOf(b.name);

        if (aIndex < bIndex) {
          return -1;
        } else if (aIndex > bIndex) {
          return 1;
        }

        return 0;
      });

      return options;
    },

    modelOptions(consideredVariants) {
      const options = [];

      const optionTemplate = {
        name: "",
        variants: [],
      };

      switch (this.product.type) {
        case "phonecase":
          {
            consideredVariants = collect(consideredVariants);

            const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
              return variant.sex;
            });

            for (let group in groupedConsideredVariants.all()) {
              const variants = groupedConsideredVariants.get(group);
              const option = clone(optionTemplate);
              const firstVariant = variants.first();
              option.name = firstVariant.sexReadable;
              option.variants = variants.all();
              options.push(option);
            }
          }
          break;
        default:
          {
            const option = clone(optionTemplate);
            option.name = "Generic Item";
            option.variants = consideredVariants.slice();
            options.push(option);
          }
          break;
      }

      const sortOrder = [
        "iPhone 16 Pro",
        "iPhone 16 Pro Max",
        "iPhone 16",
        "iPhone 16 Plus",
        "iPhone 15 Pro",
        "iPhone 15 Pro Max",
        "iPhone 15",
        "iPhone 15 Plus",
        "iPhone 14 Pro",
        "iPhone 14 Pro Max",
        "iPhone 14",
        "iPhone 14 Plus",
        "iPhone 13 Pro",
        "iPhone 13 Pro Max",
        "iPhone 13",
        "iPhone 13 Mini",
        "iPhone 12 Pro",
        "iPhone 12 Pro Max",
        "iPhone 12",
        "iPhone 12 Mini",
        "Galaxy S24 Ultra",
        "Galaxy S24 Plus",
        "Galaxy S24",
        "Galaxy S23 Ultra",
        "Galaxy S23 Plus",
        "Galaxy S23",
        "Galaxy S22 Ultra",
        "Galaxy S22 Plus",
        "Galaxy S22",
      ];

      options.sort((a, b) => {
        const aIndex = sortOrder.indexOf(a.name);
        const bIndex = sortOrder.indexOf(b.name);

        if (aIndex < bIndex) {
          return -1;
        } else if (aIndex > bIndex) {
          return 1;
        }

        return 0;
      });

      return options;
    },

    caseOptions(consideredVariants) {
      const options = [];

      const optionTemplate = {
        name: "",
        variants: [],
      };

      const metaMap = {
        Clear: {
          iconName: "phone-case-clear-detail",
          description: "UV-printed clear case.",
        },
        "Clear MagSafe": {
          iconName: "phone-case-tough-glossy-magsafe-detail",
          description: "UV-printed clear case… with magnets!",
        },
        Slim: {
          iconName: "phone-case-slim-glossy-detail",
          description: "Rich color polycarbonate shell.",
        },
        "Slim Matte": {
          iconName: "phone-case-slim-matte-detail",
          description: "Polycarbonate shell.",
        },
        Tough: {
          iconName: "phone-case-tough-glossy-detail",
          description: "Rich color polycarbonate shell + TPU liner.",
        },
        "Tough Matte": {
          iconName: "phone-case-tough-matte-detail",
          description: "Polycarbonate shell + TPU liner.",
        },
        "Tough MagSafe": {
          iconName: "phone-case-tough-glossy-magsafe-detail",
          description: "Rich color polycarbonate shell + TPU liner… with magnets!",
        },
        "Tough Matte MagSafe": {
          iconName: "phone-case-tough-matte-magsafe-detail",
          description: "Rich color polycarbonate shell + TPU liner… with magnets!",
        },
      };

      switch (this.product.type) {
        case "phonecase":
          {
            consideredVariants = collect(consideredVariants);

            const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
              return variant.size;
            });

            for (let group in groupedConsideredVariants.all()) {
              const variants = groupedConsideredVariants.get(group);
              const option = clone(optionTemplate);
              const firstVariant = variants.first();
              option.description = metaMap[firstVariant.sizeReadable].description;
              option.iconName = metaMap[firstVariant.sizeReadable].iconName;
              option.name = firstVariant.sizeReadable;
              option.variants = variants.all();
              options.push(option);
            }
          }
          break;
        default:
          {
            const option = clone(optionTemplate);
            option.name = "Generic Item";
            option.variants = consideredVariants.slice();
            options.push(option);
          }
          break;
      }

      const sortOrder = ["Tough MagSafe", "Tough Matte MagSafe", "Clear MagSafe", "Tough", "Tough Matte", "Slim", "Slim Matte", "Clear"];

      options.sort((a, b) => {
        const aIndex = sortOrder.indexOf(a.name);
        const bIndex = sortOrder.indexOf(b.name);

        if (aIndex < bIndex) {
          return -1;
        } else if (aIndex > bIndex) {
          return 1;
        }

        return 0;
      });

      return options;
    },

    colorOptions(consideredVariants) {
      const options = [];

      const optionTemplate = {
        name: "",
        colorClass: "",
        variants: [],
      };

      switch (this.product.type) {
        case "phonecase":
          {
            consideredVariants = collect(consideredVariants);

            const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
              return variant.colorReadable;
            });

            for (let group in groupedConsideredVariants.all()) {
              const variants = groupedConsideredVariants.get(group);
              const option = clone(optionTemplate);
              const firstVariant = variants.first();
              option.name = firstVariant.colorReadable;
              option.colorClass = firstVariant.iconColor;
              option.variants = variants.all();
              options.push(option);
            }
          }
          break;
        default:
          {
            const option = clone(optionTemplate);
            option.name = "Generic Item";
            option.variants = consideredVariants.slice();
            options.push(option);
          }
          break;
      }

      return options;
    },

    typeOptions(consideredVariants) {
      const options = [];

      const optionTemplate = {
        name: "",
        iconName: "",
        variants: [],
      };

      switch (this.product.type) {
        case "clothing":
          if (consideredVariants.find((variant) => variant.type === "tee")) {
            const option = clone(optionTemplate);
            option.name = "Tee";
            option.iconName = "type-tee";
            option.variants = consideredVariants.filter((variant) => variant.type === "tee");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.type === "long sleeve tee")) {
            const option = clone(optionTemplate);
            option.name = "Long Sleeve Tee";
            option.iconName = "type-long-sleeve-tee";
            option.variants = consideredVariants.filter((variant) => variant.type === "long sleeve tee");
            options.push(option);
          }

          const sweatshirtTypes = ["pullover crewneck", "sweatshirt"];
          if (consideredVariants.find((variant) => sweatshirtTypes.find((type) => variant.type === type))) {
            const option = clone(optionTemplate);
            option.name = "Pullover Crewneck";
            option.iconName = "type-sweatshirt";
            option.variants = consideredVariants.filter((variant) => sweatshirtTypes.find((type) => variant.type === type));
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.type === "pullover hoodie")) {
            const option = clone(optionTemplate);
            option.name = "Pullover Hoodie";
            option.iconName = "type-pullover-hoodie";
            option.variants = consideredVariants.filter((variant) => variant.type === "pullover hoodie");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.type === "zip-up hoodie")) {
            const option = clone(optionTemplate);
            option.name = "Zip-up Hoodie";
            option.iconName = "type-zip-hoodie";
            option.variants = consideredVariants.filter((variant) => variant.type === "zip-up hoodie");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.type === "quarter zip")) {
            const option = clone(optionTemplate);
            option.name = "Quarter-Zip Pullover";
            option.iconName = "type-zip-hoodie";
            option.variants = consideredVariants.filter((variant) => variant.type === "quarter zip");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.type === "tank")) {
            const option = clone(optionTemplate);
            option.name = "Tank";
            option.iconName = "type-tank";
            option.variants = consideredVariants.filter((variant) => variant.type === "tank");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.type === "polo")) {
            const option = clone(optionTemplate);
            option.name = "Polo";
            option.iconName = "type-polo";
            option.variants = consideredVariants.filter((variant) => variant.type === "polo");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.type === "windbreaker")) {
            const option = clone(optionTemplate);
            option.name = "Windbreaker";
            option.iconName = "type-windbreaker";
            option.variants = consideredVariants.filter((variant) => variant.type === "windbreaker");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.type === "onesie")) {
            const option = clone(optionTemplate);
            option.name = "Onesie";
            option.iconName = "type-onesie";
            option.variants = consideredVariants.filter((variant) => variant.type === "onesie");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.type === "adult onesie")) {
            const option = clone(optionTemplate);
            option.name = "Adult Onesie";
            option.iconName = "type-long-sleeve-tee";
            option.variants = consideredVariants.filter((variant) => variant.type === "adult onesie");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.type === "joggers")) {
            const option = clone(optionTemplate);
            option.name = "Joggers";
            option.iconName = "";
            option.variants = consideredVariants.filter((variant) => variant.type === "joggers");
            options.push(option);
          }
          break;
        case "hat":
          {
            const option = clone(optionTemplate);
            option.name = "Hat";
            option.iconName = "type-cap";
            option.variants = consideredVariants.slice();
            options.push(option);
          }
          break;
        case "drinkware":
          {
            const iconLookup = function (variant) {
              switch (variant.typeReadable) {
                case "Tumbler":
                  return "type-tumbler";
                case "Water Bottle":
                  return "type-bottle";
                case "Cup":
                  return "type-cup";
                case "Glass":
                  return "type-glass";
                case "Can Sleeve":
                  return "type-koozie";
                case "Mug":
                  return "type-mug";
                default:
                  return "";
              }
            };

            consideredVariants = collect(consideredVariants);

            const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
              return variant.typeReadable;
            });

            for (let group in groupedConsideredVariants.all()) {
              const variants = groupedConsideredVariants.get(group);
              const option = clone(optionTemplate);
              const firstVariant = variants.first();
              option.name = firstVariant.typeReadable;
              option.iconName = iconLookup(firstVariant);
              option.variants = variants.all();
              options.push(option);
            }
          }
          break;
        default:
          {
            const option = clone(optionTemplate);
            option.name = "Generic Item";
            option.iconName = "type-generic";
            option.variants = consideredVariants.slice();
            options.push(option);
          }
          break;
      }

      return options;
    },

    fitOptions(consideredVariants) {
      const options = [];

      const optionTemplate = {
        name: "",
        iconName: "",
        variants: [],
      };

      switch (this.product.type) {
        case "clothing":
        case "hat":
          {
            consideredVariants = collect(consideredVariants);

            const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
              return variant.sex;
            });

            for (let group in groupedConsideredVariants.all()) {
              const variants = groupedConsideredVariants.get(group);
              const option = clone(optionTemplate);
              const firstVariant = variants.first();
              option.name = firstVariant.sexReadable;
              option.variants = variants.all();
              options.push(option);
            }
          }
          break;
        default:
          {
            const option = clone(optionTemplate);
            option.name = "Generic Fit";
            option.variants = consideredVariants.slice();
            options.push(option);
          }
          break;
      }

      return options;
    },

    styleOptions(consideredVariants) {
      const options = [];

      const optionTemplate = {
        name: "",
        variants: [],
      };

      switch (this.product.type) {
        case "clothing":
          if (consideredVariants.find((variant) => ["3600", "6010", "6210"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Premium Lightweight";
            option.iconName = "tee-detail-standard";
            option.description = "Next Level, the same shirts we’ve been using for years, slim fit, S–3X";
            option.variants = consideredVariants.filter((variant) => ["3600", "6010", "6210"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["AA1070", "AA1070CV"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Standard Tee";
            option.iconName = "tee-detail-standard";
            option.description = "Alternative Apparel, fuller, contemporary cut";
            option.variants = consideredVariants.filter((variant) => ["AA1070", "AA1070CV"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["3001", "3001cvc", "3413"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Premium Lightweight";
            option.iconName = "tee-detail-standard";
            option.description = "Bella+Canvas, S–3X, slim modern fit";
            option.variants = consideredVariants.filter((variant) => ["3001", "3001cvc", "3413"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "1717")) {
            const option = clone(optionTemplate);
            option.name = "Premium Heavyweight";
            option.iconName = "tee-detail-standard";
            option.description = "Comfort Colors, classic oversized fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "1717");
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["2000", "5000"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Basic Heavyweight";
            option.iconName = "tee-detail-standard";
            option.description = "Gildan, Classic oversized fit, S–5X";
            option.variants = consideredVariants.filter((variant) => ["2000", "5000"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["3930r"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Heavyweight Tee";
            option.iconName = "tee-detail-standard";
            option.description = "Classic oversized fit, S–5X";
            option.variants = consideredVariants.filter((variant) => ["3930r"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["2574"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Work Shirt";
            option.iconName = "tee-detail-standard";
            option.description = "Dickies, oversized fit";
            option.variants = consideredVariants.filter((variant) => ["2574"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "64000")) {
            const option = clone(optionTemplate);
            option.name = "Basic Lightweight";
            option.iconName = "tee-detail-standard";
            option.description = "Gildan, modern classic fit, S–3X";
            option.variants = consideredVariants.filter((variant) => variant.code === "64000");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "servedfresh")) {
            const option = clone(optionTemplate);
            option.name = "Standard Tee";
            option.iconName = "tee-detail-standard";
            option.description = "ServedFresh, slim modern fit, XS–3X";
            option.variants = consideredVariants.filter((variant) => variant.code === "servedfresh");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "PC54R")) {
            const option = clone(optionTemplate);
            option.name = "Ringer Tee";
            option.iconName = "tee-detail-standard";
            option.description = "Port & Company, modern classic fit, S–2X";
            option.variants = consideredVariants.filter((variant) => variant.code === "PC54R");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "64500B")) {
            const option = clone(optionTemplate);
            option.name = "Youth Tee";
            option.iconName = "tee-detail-standard";
            option.description = "Gildan, classic oversized fit, XS–XL";
            option.variants = consideredVariants.filter((variant) => variant.code === "64500B");
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["CBM101", "CBM301"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Premium Tee";
            option.iconName = "tee-detail-premium";
            option.description = "Blank by CB, XS–5X, made in the USA, a little more forgiving";
            option.variants = consideredVariants.filter((variant) => ["CBM101", "CBM301"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.manufacturer === "american apparel" && variant.sex === "men" && variant.code !== "bb453")) {
            const option = clone(optionTemplate);
            option.name = "Standard Tee";
            option.iconName = "tee-detail-standard";
            option.description = "American Apparel, the same shirts we’ve been using for years, slim fit";
            option.variants = consideredVariants.filter((variant) => variant.manufacturer === "american apparel" && variant.sex === "men" && variant.code !== "bb453");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "a376")) {
            const option = clone(optionTemplate);
            option.name = "Performance Tee";
            option.iconName = "tee-detail-standard";
            option.description = "Adidas, S–4X, slim fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "a376");
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["3300L", "3900", "6610", "6710"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Junior Fit Tee";
            option.iconName = "tee-detail-junior";
            option.description = "Next Level, S–2X, runs very small and fitted";
            option.variants = consideredVariants.filter((variant) => ["3300L", "3900", "6610", "6710"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["CBW101", "CBW301"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "True to Size Tee";
            option.iconName = "tee-detail-true";
            option.description = "Blank by CB, XS–5X, made in the USA, fits like it should";
            option.variants = consideredVariants.filter((variant) => ["CBW101", "CBW301"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "6400")) {
            const option = clone(optionTemplate);
            option.name = "True to Size Tee";
            option.iconName = "tee-detail-true";
            option.description = "Bella+Canvas, S–2X, fits like it should";
            option.variants = consideredVariants.filter((variant) => variant.code === "6400");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "18000")) {
            const option = clone(optionTemplate);
            option.name = "Basic Midweight";
            option.iconName = "crewneck-detail";
            option.description = "Gildan, midweight crewneck, S–3X";
            option.variants = consideredVariants.filter((variant) => variant.code === "18000");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.manufacturer === "american apparel" && variant.sex === "women")) {
            const option = clone(optionTemplate);
            option.name = "Junior Fit Tee";
            option.iconName = "tee-detail-junior";
            option.description = "American Apparel, XS–2X, runs very small and fitted";
            option.variants = consideredVariants.filter((variant) => variant.manufacturer === "american apparel" && variant.sex === "women");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "a377")) {
            const option = clone(optionTemplate);
            option.name = "Performance Tee";
            option.iconName = "tee-detail-junior";
            option.description = "Adidas, S–3X, slim fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "a377");
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["royal-20051", "royal-5051"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Standard Tee";
            option.iconName = "tee-detail-standard";
            option.description = "Royal Apparel, XS–3X, slim fit";
            option.variants = consideredVariants.filter((variant) => ["royal-20051", "royal-5051"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["royal-20001", "royal-5001J"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Junior Fit Tee";
            option.iconName = "tee-detail-junior";
            option.description = "Royal Apparel, XS–2X, runs very small and fitted";
            option.variants = consideredVariants.filter((variant) => ["royal-20001", "royal-5001J"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["3501", "3501CVC", "3513"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Premium Lightweight";
            option.iconName = "long-sleeve-tee-detail-standard";
            option.description = "Bella+Canvas, XS–2X, unisex fit";
            option.variants = consideredVariants.filter((variant) => ["3501", "3501CVC", "3513"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "3601")) {
            const option = clone(optionTemplate);
            option.name = "Premium Lightweight";
            option.iconName = "long-sleeve-tee-detail-standard";
            option.description = "Next Level, S–2X, unisex fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "3601");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "5400")) {
            const option = clone(optionTemplate);
            option.name = "Basic Heavyweight";
            option.iconName = "long-sleeve-tee-detail-standard";
            option.description = "Gildan, classic oversized fit, S–3X";
            option.variants = consideredVariants.filter((variant) => variant.code === "5400");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "bb453")) {
            const option = clone(optionTemplate);
            option.name = "Standard Raglan Tee";
            option.iconName = "long-sleeve-tee-detail-standard";
            option.description = "American Apparel, S–XL, men’s fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "bb453");
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["3480", "3480cvc", "3484"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Premium Lightweight";
            option.iconName = "tank-detail";
            option.description = "Bella+Canvas, XS–2X, unisex fit";
            option.variants = consideredVariants.filter((variant) => ["3480", "3480cvc", "3484"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "tr408")) {
            const option = clone(optionTemplate);
            option.name = "Tank top";
            option.iconName = "tank-detail";
            option.description = "American Apparel, S–XL, men’s fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "tr408");
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["EXP54LWZ", "EXP99CNB"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Windbreaker";
            option.iconName = "windbreaker-detail";
            option.description = "Independent, XS–3X, slim fit";
            option.variants = consideredVariants.filter((variant) => ["EXP54LWZ", "EXP99CNB"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["EXP20PQ"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Quarter-Zip Pullover";
            option.iconName = "windbreaker-detail";
            option.description = "Independent, XS–3X, standard fit";
            option.variants = consideredVariants.filter((variant) => ["EXP20PQ"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "3638071")) {
            const option = clone(optionTemplate);
            option.name = "Polo";
            option.iconName = "polo-detail";
            option.description = "Nike Dri-FIT";
            option.variants = consideredVariants.filter((variant) => variant.code === "3638071");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "1566")) {
            const option = clone(optionTemplate);
            option.name = "Premium Heavyweight";
            option.iconName = "crewneck-detail";
            option.description = "Comfort Colors, heavyweight crewneck";
            option.variants = consideredVariants.filter((variant) => variant.code === "1566");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "3901")) {
            const option = clone(optionTemplate);
            option.name = "Premium Midweight";
            option.iconName = "crewneck-detail";
            option.description = "Bella+Canvas, XS–2X, sponge fleece, super soft and cozy";
            option.variants = consideredVariants.filter((variant) => variant.code === "3901");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "3945")) {
            const option = clone(optionTemplate);
            option.name = "Pullover Crewneck";
            option.iconName = "crewneck-detail";
            option.description = "Bella+Canvas, XS–2X, sponge fleece, drop shoulder, super soft and cozy";
            option.variants = consideredVariants.filter((variant) => variant.code === "3945");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "AA9575")) {
            const option = clone(optionTemplate);
            option.name = "Pullover Crewneck";
            option.iconName = "crewneck-detail";
            option.description = "Alternative Apparel, eco-fleece, slim fit for men";
            option.variants = consideredVariants.filter((variant) => variant.code === "AA9575");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "5454")) {
            const option = clone(optionTemplate);
            option.name = "Pullover Crewneck";
            option.iconName = "crewneck-detail";
            option.description = "American Apparel, California fleece raglan";
            option.variants = consideredVariants.filter((variant) => variant.code === "5454");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "SS3000")) {
            const option = clone(optionTemplate);
            option.name = "Pullover Crewneck";
            option.iconName = "crewneck-detail";
            option.description = "Independent, midweight crewneck";
            option.variants = consideredVariants.filter((variant) => variant.code === "SS3000");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "IND4000")) {
            const option = clone(optionTemplate);
            option.name = "Premium Heavyweight";
            option.iconName = "hoodie-detail";
            option.description = "Independent, classic oversized fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "IND4000");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "ascolour|5102")) {
            const option = clone(optionTemplate);
            option.name = "Pullover Hoodie";
            option.iconName = "hoodie-detail";
            option.description = "ASColour, regular fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "ascolour|5102");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "ascolour|5921")) {
            const option = clone(optionTemplate);
            option.name = "Trackpants";
            option.iconName = "";
            option.description = "ASColour, regular fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "ascolour|5921");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "G18500")) {
            const option = clone(optionTemplate);
            option.name = "Basic Midweight";
            option.iconName = "hoodie-detail";
            option.description = "Gildan, classic oversized fit, S–5X";
            option.variants = consideredVariants.filter((variant) => variant.code === "G18500");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "S101")) {
            const option = clone(optionTemplate);
            option.name = "Pullover Hoodie";
            option.iconName = "hoodie-detail";
            option.description = "Champion, classic oversized fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "S101");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "9302")) {
            const option = clone(optionTemplate);
            option.name = "Pullover Hoodie";
            option.iconName = "hoodie-detail";
            option.description = "Next Level, classic fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "9302");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "3719")) {
            const option = clone(optionTemplate);
            option.name = "Premium Midweight";
            option.iconName = "hoodie-detail";
            option.description = "Bella+Canvas, sponge fleece, super soft and cozy";
            option.variants = consideredVariants.filter((variant) => variant.code === "3719");
            options.push(option);
          }

          if (consideredVariants.find((variant) => ["3739", "3909"].includes(variant.code))) {
            const option = clone(optionTemplate);
            option.name = "Premium Midweight";
            option.iconName = "zip-hoodie-detail";
            option.description = "Bella+Canvas, XS–2X, sponge fleece, super soft and cozy";
            option.variants = consideredVariants.filter((variant) => ["3739", "3909"].includes(variant.code));
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "99100")) {
            const option = clone(optionTemplate);
            option.name = "Pullover Crewneck";
            option.iconName = "crewneck-detail";
            option.description = "Delta, S–3X, classic oversized fit, super soft and cozy";
            option.variants = consideredVariants.filter((variant) => variant.code === "99100");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "99300")) {
            const option = clone(optionTemplate);
            option.name = "Zip-Up Hoodie";
            option.iconName = "zip-hoodie-detail";
            option.description = "Delta, S–3X, classic oversized fit, super soft and cozy";
            option.variants = consideredVariants.filter((variant) => variant.code === "99300");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "IND4000Z")) {
            const option = clone(optionTemplate);
            option.name = "Premium Heavyweight";
            option.iconName = "zip-hoodie-detail";
            option.description = "Independent, classic oversized fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "IND4000Z");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "18600")) {
            const option = clone(optionTemplate);
            option.name = "Basic Midweight";
            option.iconName = "zip-hoodie-detail";
            option.description = "Gildan, classic oversized fit";
            option.variants = consideredVariants.filter((variant) => variant.code === "18600");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "3321")) {
            const option = clone(optionTemplate);
            option.name = "Toddler Tee";
            option.iconName = "tee-detail-standard";
            option.description = "Rabbit skins, 2–5/6, a little boxy";
            option.variants = consideredVariants.filter((variant) => variant.code === "3321");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "3322")) {
            const option = clone(optionTemplate);
            option.name = "Infant Tee";
            option.iconName = "tee-detail-standard";
            option.description = "Rabbit skins, 6M–24M, a little boxy";
            option.variants = consideredVariants.filter((variant) => variant.code === "3322");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "4424")) {
            const option = clone(optionTemplate);
            option.name = "Infant Onesie";
            option.iconName = "onesie-detail";
            option.description = "Rabbit skins, NB–24M, a little boxy";
            option.variants = consideredVariants.filter((variant) => variant.code === "4424");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "FDRF-adult-onesie")) {
            const option = clone(optionTemplate);
            option.name = "Adult Onesie";
            option.iconName = "long-sleeve-tee-detail-standard";
            // option.description = "";
            option.variants = consideredVariants.filter((variant) => variant.code === "FDRF-adult-onesie");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "6101")) {
            const option = clone(optionTemplate);
            option.name = "Youth Tee";
            option.iconName = "tee-detail-standard";
            option.description = "Rabbit skins, XS–XL, a little boxy";
            option.variants = consideredVariants.filter((variant) => variant.code === "6101");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "mystery-men-tee")) {
            const option = clone(optionTemplate);
            option.name = "Mystery Tee";
            option.iconName = "tee-detail-standard";
            option.description = "A t-shirt or tanktop. Includes a variety of brands and fits.";
            option.variants = consideredVariants.filter((variant) => variant.code === "mystery-men-tee");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "mystery-women-tee")) {
            const option = clone(optionTemplate);
            option.name = "Mystery Tee";
            option.iconName = "tee-detail-junior";
            option.description = "A t-shirt. Includes a variety of brands and fits.";
            option.variants = consideredVariants.filter((variant) => variant.code === "mystery-women-tee");
            options.push(option);
          }

          if (consideredVariants.find((variant) => variant.code === "mystery-sweatshirt")) {
            const option = clone(optionTemplate);
            option.name = "Mystery Sweatshirt";
            option.iconName = "crewneck-detail";
            option.description = "Zip-up hoodies, pullover hoodies, and pullover crewnecks. Includes a variety of brands and fits.";
            option.variants = consideredVariants.filter((variant) => variant.code === "mystery-sweatshirt");
            options.push(option);
          }

          options.sort((a, b) => {
            if (a.name < b.name) {
              return 1;
            } else if (a.name > b.name) {
              return -1;
            }

            return 0;
          });

          break;
        case "hat":
          {
            if (consideredVariants.find((variant) => variant.code === "mystery-hat")) {
              const option = clone(optionTemplate);
              option.name = "Mystery Hat";
              option.iconName = "curved-cap-detail";
              option.description = "Dad hats, snapbacks, and truckers. Includes a variety of brands. All are one size fits all.";
              option.variants = consideredVariants.filter((variant) => variant.code === "mystery-hat");
              options.push(option);
            } else {
              consideredVariants = collect(consideredVariants);

              const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
                return `${variant.manufacturer} ${variant.type}`;
              });

              for (let group in groupedConsideredVariants.all()) {
                const variants = groupedConsideredVariants.get(group);
                const option = clone(optionTemplate);
                const firstVariant = variants.first();
                option.name = `${firstVariant.typeReadable}`;
                // option.iconName = "";
                // option.description = "";
                option.variants = variants.all();
                options.push(option);
              }
            }
          }
          break;
        case "drinkware":
          {
            const descriptionLookup = function (variant) {
              switch (variant.sexReadable) {
                case "Everyday Tumbler":
                  return "Double-wall insulation, quick-toggle lid. Goes where you do.";
                case "Pint Glass":
                  return "Tempered glass, large capacity. Functional and inconspicuous.";
                case "Skinny Water Bottle":
                  return "Double-wall insulation, leak-proof screw-on cap. Good for backpacks.";
                case "Everyday Straw Cup":
                  return "Double-wall insulation, screw-on lid with straw. Fine sipping.";
                case "Rocks Glass":
                  return "Tempered glass, low profile. Holds just enough.";
                case "Skinny Can Sleeve":
                  return "Double-wall insulation, slender shape for a tall drink of water.";
                case "Everyday Can Sleeve":
                  return "Double-wall insulation, thick build for a classic beverage.";
                case "Everyday Mug":
                  return "Holds one 11oz dose of hot liquid. Built like a tank. Free refills.";
                default:
                  return "";
              }
            };

            {
              consideredVariants = collect(consideredVariants);

              const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
                return variant.sexReadable;
              });

              for (let group in groupedConsideredVariants.all()) {
                const variants = groupedConsideredVariants.get(group);
                const option = clone(optionTemplate);
                const firstVariant = variants.first();
                option.name = firstVariant.sexReadable;
                option.iconName = firstVariant.iconTemplate;
                option.description = descriptionLookup(firstVariant);
                option.variants = variants.all();
                options.push(option);
              }
            }
          }
          break;
        default:
          {
            const option = clone(optionTemplate);
            option.name = "Generic Style";
            option.iconName = "generic-detail";
            // option.description = "";
            option.variants = consideredVariants.slice();
            options.push(option);
          }
          break;
      }

      if (options.length < 1) {
        if (consideredVariants.length > 0) {
          const variant = consideredVariants[0];
          console.log(`Unable to find any matching style options for id:${variant.id}: code:${variant.code}`);
        } else {
          console.log("Unable to find any matching style options");
        }
      }

      return options;
    },

    colorMaterialOptions(consideredVariants) {
      const options = [];

      const optionTemplate = {
        name: "",
        colorClass: "",
        heathered: false,
        variants: [],
      };

      switch (this.product.type) {
        case "clothing":
          {
            if (this.product.id == 2002) {
              // mystery
              const option = clone(optionTemplate);
              option.name = "It’s a mystery";
              option.colorClass = "White";
              option.heathered = false;
              option.variants = consideredVariants;
              options.push(option);
            } else {
              consideredVariants = collect(consideredVariants);

              const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
                return `${variant.colorReadable} ${variant.materialReadable}`;
              });

              for (let group in groupedConsideredVariants.all()) {
                const variants = groupedConsideredVariants.get(group);
                const option = clone(optionTemplate);
                const firstVariant = variants.first();
                option.name = group;
                option.colorClass = firstVariant.iconColor;
                option.heathered = firstVariant.iconTexture;
                option.variants = variants.all();
                options.push(option);
              }
            }
          }
          break;
        case "hat":
          {
            if (this.product.id == 81505) {
              // mystery
              const option = clone(optionTemplate);
              option.name = "It’s a mystery";
              option.colorClass = "White";
              option.heathered = false;
              option.variants = consideredVariants;
              options.push(option);
            } else {
              consideredVariants = collect(consideredVariants);

              const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
                return `${variant.colorReadable} ${variant.materialReadable}`;
              });

              for (let group in groupedConsideredVariants.all()) {
                const variants = groupedConsideredVariants.get(group);
                const option = clone(optionTemplate);
                option.name = group;
                option.colorClass = variants.first().iconColor;
                option.heathered = variants.first().iconTexture;
                option.variants = variants.all();
                options.push(option);
              }
            }
          }
          break;
        case "drinkware":
          {
            consideredVariants = collect(consideredVariants);

            const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
              return variant.colorReadable;
            });

            for (let group in groupedConsideredVariants.all()) {
              const variants = groupedConsideredVariants.get(group);
              const option = clone(optionTemplate);
              const firstVariant = variants.first();
              option.name = firstVariant.colorReadable;
              option.colorClass = firstVariant.iconColor;
              option.variants = variants.all();
              options.push(option);
            }
          }
          break;
        default:
          {
            consideredVariants = collect(consideredVariants);

            const groupedConsideredVariants = consideredVariants.groupBy((variant, key) => {
              return `${variant.colorReadable} ${variant.materialReadable}`;
            });

            for (let group in groupedConsideredVariants.all()) {
              const variants = groupedConsideredVariants.get(group);
              const option = clone(optionTemplate);
              option.name = group;
              option.colorClass = variants.first().iconColor;
              option.heathered = variants.first().iconTexture;
              option.variants = variants.all();
              options.push(option);
            }
          }
          break;
      }

      return options;
    },

    sizeOptions(consideredVariants) {
      let options = [];

      const optionTemplate = {
        name: "",
        variants: [],
      };

      switch (this.product.type) {
        case "clothing":
        case "challenge-coin":
        case "hat":
        case "mug":
        case "pillow":
        case "pin":
        default:
          options = consideredVariants.map((variant) => {
            const option = clone(optionTemplate);
            option.name = variant.sizeReadable;
            option.variants.push(variant);
            return option;
          });

          break;
      }

      return options;
    },

    subscriptionOptions(consideredVariants) {
      let options = [];

      const optionTemplate = {
        name: "",
        variants: [],
      };

      options = consideredVariants.map((variant) => {
        const option = clone(optionTemplate);

        if (variant.subscriptions.length) {
          option.name = "Quarterly Subscription";
          option.variants.push(variant);
        } else {
          option.name = "Standard Journal";
          option.variants.push(variant);
        }

        return option;
      });

      return options;
    },

    selectOption(choiceIndex, option, causedByUserAction) {
      const c = this.activeChoices[choiceIndex];
      c.selectedOption = option;
      this.selectedOptions[choiceIndex] = option;

      choiceIndex++;

      if ("nextChoice" in option) {
        this.activeChoices[choiceIndex] = option.nextChoice;
        this.selectOption(choiceIndex, option.nextChoice.selectedOption, false);
      } else {
        // Remove the remaining choices
        this.activeChoices.splice(choiceIndex, this.activeChoices.length);
        // Last choice sets the variant
        this.selectedVariant = option.variants[0];
        const id = this.selectedVariant.id;
        const label = slugify(this.activeChoices.map((choice) => choice.selectedOption.name).join("-"), { lower: true });
        this.$router.replace({ name: "variant", params: { id: id, label: label } }).catch((err) => {});
        this.userMadeFinalChoice = causedByUserAction;

        // If there is only one option for this choice, it can be selected by default
        if (c.options.length <= 1) {
          this.userMadeFinalChoice = true;
        }

        // If the product is Cortex - The Theme System Journal, it can be selected by default
        if (this.product.id == 53069) {
          this.userMadeFinalChoice = true;
        }

        // If the product is a phone case, it can be selected by default
        if (this.product.type === "phonecase") {
          this.userMadeFinalChoice = true;
        }
      }
    },

    showChoice(choiceIndex) {
      const choiceExists = choiceIndex < this.activeChoices.length;

      if (choiceExists) {
        if (this.product.isExpired || this.isDisabledLegacyClockwiseOnDemandProduct) {
          return "nextChoice" in this.selectedOptions[choiceIndex];
        }

        return true;
      } else {
        return false;
      }
    },

    addToBag() {
      let items = [
        {
          variant_id: this.selectedVariant.id,
          quantity: 1,
        },
      ];

      this.sendAnalyticData(true);
      this.sendBreadcrumb();

      let data = {
        items: JSON.stringify(items),
      };

      this.$emit("add-to-bag", data);
    },

    sendAnalyticData(isAddToBag) {
      if (isAddToBag) {
        gtag("event", "add_to_cart", {
          currency: "USD",
          value: this.selectedVariant.price,
          items: [
            {
              item_id: this.product.id,
              item_name: this.product.title,
              price: this.selectedVariant.price,
              quantity: 1,
            },
          ],
        });

        // Cortex
        if (this.product.designer.id == 46542) {
          fbq("init", "362732092065896");
        }

        fbq("track", "AddToCart", {
          content_name: this.product.title,
          contents: [
            {
              id: this.product.id,
              quantity: 1,
            },
          ],
          content_type: "product",
          value: this.selectedVariant.price,
          currency: "USD",
        });
      } else {
        // Cortex
        if (this.product.designer.id == 46542) {
          fbq("init", "362732092065896");
          fbq("trackSingle", "362732092065896", "PageView");
        }

        fbq("track", "ViewContent", {
          content_name: this.product.title,
          content_ids: [this.product.id],
          content_type: "product",
        });
      }
    },

    sendBreadcrumb() {
      // Raven.captureBreadcrumb({
      //   message: 'Item added to shopping bag',
      //   category: 'action',
      //   data: this.purchaseData
      // });
    },

    viewSizeChart() {
      const productDetails = document.getElementsByClassName("apparel-resources");

      if (productDetails && productDetails.length) {
        Velocity(productDetails[0], "scroll");
      }
    },

    toLocaleString(datetime, preset) {
      return DateTime.fromISO(datetime).toLocaleString(DateTime[preset]);
    },

    toLocaleString(datetime, format) {
      return DateTime.fromISO(datetime).toLocaleString(format);
    },

    currentSubscription() {
      if (this.product.subscriptions.length) {
        return this.product.subscriptions.filter((s) => DateTime.now() < DateTime.fromISO(s.cloneAfter)).shift();
      }
    },

    // Blank Details
    isEvenRow(index) {
      return (index + 1) % 2;
    },

    mapIconTemplate(iconTemplate) {
      return ICON_TEMPLATE_MAP[iconTemplate] ? ICON_TEMPLATE_MAP[iconTemplate] : "detailInfo";
    },

    openModal(key) {
      this.$emit("open-modal", key);
    },

    // Social Buttons
    triggerShare(socialPlatform, event) {
      let target = event.target;

      while (target && target.nodeName.toLowerCase() !== "a") {
        target = target.parentNode;
      }

      switch (socialPlatform) {
        case "pinterest":
          window.open(target.href, "pinterest", "height=316, width=750");
          break;
        case "facebook":
          window.open(target.href, "facebook", "height=655, width=522");
          break;
        case "bluesky":
          this.handleBluesky(target);
          break;
      }
    },

    handleBluesky(target) {
      let intentRegex = /bsky\.app(:\d{2,4})?\/intent\/(\w+)/;
      let windowOptions = "scrollbars=yes,resizable=yes,toolbar=no,location=yes";
      let width = 700;
      let height = 420;
      let winHeight = screen.height;
      let winWidth = screen.width;

      let left;
      let top;

      if (target.href.match(intentRegex)) {
        left = Math.round(winWidth / 2 - width / 2);
        top = 0;

        if (winHeight > height) {
          top = Math.round(winHeight / 2 - height / 2);
        }

        window.open(target.href, "intent", windowOptions + ",width=" + width + ",height=" + height + ",left=" + left + ",top=" + top);
      }
    },

    createFromProductUrl() {
      const query = qs.stringify(
        {
          fromId: this.product.id,
          toType: "phonecase",
        },
        true,
      );

      return `${SITE_URL}create-a-product${query}`;
    },

    onCopy(text) {
      navigator.clipboard.writeText(text);
    },
  },
};
</script>
